module.exports = __webpack_public_path__ + "static/media/jbl-t210.5f647f7b.jpeg";